module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Align-center-297face20c5ba63a218becb50de182fa.svg";